import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Array
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface CopyControllerTargetLifecycleHooks {
  public fun sourceTargetConnected(element: HTMLElement) {
  }

  public fun sourceTargetDisconnected(element: HTMLElement) {
  }
}

public fun <T : HTMLElement> CopyController.sourceTarget(): StimulusProperty<T> =
    StimulusProperty("sourceTarget")

public fun <T : HTMLElement> CopyController.sourceTargets(): StimulusProperty<Array<T>> =
    StimulusProperty("sourceTargets")

public fun registerCopyController(stimulus: Application) {
   val clazz = CopyController::class
   val properties = object  {
      // Js name needed otherwise Kotlin will mangle the name
      @JsName("targets")
      val targets = js("['source']")

      @JsName("values")
      val values = buildValues(
          setOf(
              
          ),
          null
      )
      
      
      
      @JsName("classes")
      val classes = js("[]")
  }

  val factoryFunc = clazz.js.asDynamic()

  addStaticMembersTo(factoryFunc, properties)
  val controllerName = "copy"
  println("Registering controller copy")

  stimulus.register(controllerName, factoryFunc)
}
